import moment from 'moment';
import db from '@/store/db';
import log from '@/logger';

export default {
  getDefaultTodoItem: (projectId, partId) => {
    return {
      title: 'New TodoItem',
      projectId: projectId,
      partId: partId,
      type: 'TodoItem',
      archived: false,
      lastUpdate: {},
      checked: false,
      checkedAt: moment().format(),
      checkedBy: '',
      colour: '#000000',
      icon: '',
      sort: 0,
      createdAt: moment().format(),
    };
  },
  newTodoItem: function (projectId, partId, newTodoItemProperties) {
    return Object.assign({}, this.getDefaultTodoItem(projectId, partId), newTodoItemProperties || {});
  },
  createTodoItem: function (projectId, partId, newTodoItemProperties) {
    // console.log('api:createTodoItem');
    var newTodoItem = this.newTodoItem(projectId, partId, newTodoItemProperties);
    return this.saveTodoItem(newTodoItem);
  },
  saveTodoItem: function (todoItem) {
    if (todoItem._id) {
      return db.currentProjectDb.put(todoItem).then((response) => {
        let udatedTodoItem = Object.assign({}, todoItem, { _rev: response.rev });
        return udatedTodoItem;
      });
    } else {
      return db.currentProjectDb.post(todoItem).then(function (doc) {
        todoItem._id = doc.id;
        todoItem._rev = doc.rev;
        return todoItem;
      });
    }
  },
  saveTodoItems: function (todoItems) {
    return db.currentProjectDb.bulkDocs(todoItems);
  },
  getTodoItems: function (projectId, partId) {
    return db.loadedDatabases[projectId]
      .query('todoItems', {
        include_docs: true,
        startkey: [projectId, partId],
        endkey: [projectId, partId],
      })
      .then((result) => {
        let populated = [];
        for (var todoItem of result.rows) {
          todoItem = Object.assign(this.getDefaultTodoItem(projectId, partId), todoItem.doc);
          populated.push(todoItem);
        }

        return populated;
      })
      .catch(function (err) {
        log.error('Unable to load todoItems', err);
      });
  },

  getTodoItem: async function (id) {
    if (!db.currentProjectDb.get) {
      return;
    }
    return db.currentProjectDb.get(id);
  },
};



// WEBPACK FOOTER //
// ./src/store/todoItem/todoItemApi.js